(() => {
  let teardown = () => {};
  function initialize() {
    teardown();
    const product = document.querySelector('.vf-premium-product');
    if (!product) { teardown = () => {}; return; }
    const info = product.querySelector('.product__info-container');
    const gallery = product.querySelector('.product__media-wrapper');
    const title = info?.querySelector('.vf-product-title-wrap');
    const benefit = info?.querySelector('.vf-chlorine-benefit');
    if (!gallery || !title || !benefit) { teardown = () => {}; return; }
    const titleHome = document.createComment('vf98 original title position');
    const benefitHome = document.createComment('vf98 original benefit position');
    title.before(titleHome); benefit.before(benefitHome);
    const intro = document.createElement('div');
    intro.className = 'vf98-mobile-intro';
    intro.setAttribute('data-vf98-mobile-intro', '');
    gallery.before(intro);
    const phone = matchMedia('(max-width: 749px)');
    function restore() {
      if (titleHome.isConnected) titleHome.after(title);
      if (benefitHome.isConnected) benefitHome.after(benefit);
    }
    function update() {
      if (phone.matches) {
        intro.append(title, benefit);
      } else {
        restore();
      }
    }
    phone.addEventListener('change', update);
    update();
    teardown = () => {
      phone.removeEventListener('change', update);
      restore();
      titleHome.remove(); benefitHome.remove(); intro.remove();
    };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true }); else initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(initialize));
})();
